module.exports = __webpack_public_path__ + "img/iwaly.0c2f9864.svg";